import React from 'react';
import {Box, Typography} from '@mui/material';
import Entries from './Entries';
import {ResourceContextProvider} from 'components/record/ResourceContext';

const EntriesPage = () => {
  return (
    <Box sx={{p: 3}}>
      <Typography variant="h4" gutterBottom>
        Entries Management
      </Typography>
      <ResourceContextProvider resource="Entry">
        <Entries />
      </ResourceContextProvider>
    </Box>
  );
};

export default EntriesPage;
